import { useSocialContext } from '../context/SocialContext';

// Mirror of useCollection — thin wrapper so components import a hook, not
// the context module.
export const useSocial = () => {
  return useSocialContext();
};

export default useSocial;
